import { LOCAL_STORAGE_USER_LOGIN_INFO, ODER_BY_TYPE, ORDER_BY } from '@app/constants/Common';
import {
    DVTJCUVConnectCddEmpParentTabs
} from '@pages/dvtjcuv/common/ConnectCddEmpTabs';
import UpdateDVTJCUVPipelineModal from "@pages/dvtjcuv/edit/UpdateDVTJCUVPipelineModal";
import DVTJCUVPipelineTableList, { DVTJCUVPipelineListMode } from "@pages/dvtjcuv/list/DVTJCUVPipelineTableList";
import { requestGetDVTJCUVPipeLineList } from "@pages/dvtjcuv/service/DVTJCUVPipelineService";
import React, { useEffect, useState } from 'react';



const ConnectCddEmpPaymentAndWarrantyTabContent = (props) => {
    const [pipeline1List, setPipeline1List] = useState([]);
    const [pipeline2List, setPipeline2List] = useState([]);
    const [showInputCddGPEmpDiscussion, setShowInputCddGPEmpDiscussion] = useState(false);
    const [showUpdatePipelineModal, setShowUpdatePipelineModal] = useState(false);
    const [selectPipeline, setSelectPipeline] = useState({});
    const [sort1Columns, setSort1Columns] = useState({
        created_date_time: ORDER_BY.DESC_UPDATE_DATE
    });
    const [sort2Columns, setSort2Columns] = useState({
        created_date_time: ORDER_BY.DESC_UPDATE_DATE
    });

    const {data} = props

    const pTab = DVTJCUVConnectCddEmpParentTabs.PAYMENT_AND_WARRANTY_TAB

    const [userLoginInfo, setUserLoginInfo] = useState({});
    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)
        }
    }, [])

    const fetchPipeLines = async (searchConds, sortColumns = {created_date_time: ORDER_BY.DESC_UPDATE_DATE}) => {
        if (!searchConds) {
            searchConds = {}
        }

        searchConds.parent_tab = pTab?.id
        searchConds.unlimited = true

        const params = {
            search_conditions: searchConds,
            sort_columns: sortColumns
        }

        const res = await requestGetDVTJCUVPipeLineList(params);
        return res.content.pipelines
    }

    const fetchPipeLine1List = async (sortColumns) => {
        const pipelines = await fetchPipeLines({cdd_emp_fu_needed: "follow up cdd;follow up emp"}, sortColumns)
        setPipeline1List(pipelines)
    }

    const fetchPipeLine2List = async (sortColumns) => {
        const pipelines = await fetchPipeLines({cdd_emp_fu_needed_except: "follow up cdd;follow up emp"}, sortColumns)
        setPipeline2List(pipelines)
    }

    const onShowEditPipeline = (item, fromReferee) => {
        item.fromReferee = !!fromReferee
        setSelectPipeline({...item})
        setShowUpdatePipelineModal(true)
    }

    const onInputGPEmpDiscussion = () => {
        setShowInputCddGPEmpDiscussion(true)
    }

    const onSort = async (columnKey, table1 = true) => {
        let newSorts = {...sort1Columns}
        if (!table1) {
            newSorts = {...sort2Columns}
        }
        if (newSorts[columnKey] && newSorts[columnKey] === ODER_BY_TYPE.ASC) {
            newSorts[columnKey] = ODER_BY_TYPE.DESC
        } else {
            newSorts = {}
            newSorts[columnKey] = ODER_BY_TYPE.ASC
        }
        if (table1) {
            setSort1Columns(newSorts)
            await fetchPipeLine1List(newSorts)
        } else {
            setSort2Columns(newSorts)
            await fetchPipeLine2List(newSorts)
        }
    }

    const onSort1 = async (columnKey) => {
        await onSort(columnKey, true)
    }
    const onSort2 = async (columnKey) => {
        await onSort(columnKey, false)
    }

    useEffect(() => {
        fetchPipeLine1List()
        fetchPipeLine2List()
    }, []);

    return (
        <>
            <div className={'card card-default'}>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>
                        DVTJCUV pipelines (FU needed (Cdd-Emp) là [Follow up Cdd] hoặc [Follow up Emp])
                    </h3>
                </div>
                <div className='card-body'>
                    <DVTJCUVPipelineTableList
                        pipeLines={pipeline1List}
                        mode={DVTJCUVPipelineListMode.RUN_DVTJCUV_CONNECT_CDD_EMP}
                        parentTabId={pTab.id}
                        // subTabId={currentTab.id}
                        onSort={onSort1}
                        sortColumn={sort1Columns}
                        onEditItem={(selectItem, fromReferee) => onShowEditPipeline(selectItem, fromReferee)}
                    />
                </div>
            </div>
            <div className={'card card-default'}>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>
                        DVTJCUV pipelines (Others)
                    </h3>
                </div>
                <div className='card-body'>
                    <DVTJCUVPipelineTableList
                        pipeLines={pipeline2List}
                        mode={DVTJCUVPipelineListMode.RUN_DVTJCUV_CONNECT_CDD_EMP}
                        parentTabId={pTab.id}
                        // subTabId={currentTab.id}
                        onSort={onSort2}
                        sortColumn={sort2Columns}
                        onEditItem={(selectItem, fromReferee) => onShowEditPipeline(selectItem, fromReferee)}
                    />
                </div>
            </div>
            {showUpdatePipelineModal &&
            <UpdateDVTJCUVPipelineModal isShow={showUpdatePipelineModal}
                                        pipeLineInfo={selectPipeline}
                                        onClose={(reload) => setShowUpdatePipelineModal(false)}
            />
            }
        </>
    )
}

export default ConnectCddEmpPaymentAndWarrantyTabContent;
